/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;
  return {
    bottomButton: {
      position: 'relative',
      width: '100%',
      background: 'unset',
      padding: 0,
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    sheetContainer: {
      // background: theme.backgroundColor,
      // borderRadius: '15px 15px 0 0',
    },
    sheetHeader: {
      background: theme.backgroundColor,
      borderRadius: '15px 15px 0 0',
    },
    sheetContent: {
      background: theme.backgroundColor,
    },
    '@global': {
      body: {
        color: 'white',
      },
      '.ant-form-item-label>label, .ant-form': {
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
    title: {
      margin: [10, 0, 20],
      fontSize: 20,
      fontWeight: '700',
    },
    iconButton: {
      alignItems: 'center',
      background: 'transparent',
      borderRadius: '50%',
      height: 80,
      width: 80,
      zIndex: 1,
      '&.ant-btn': {
        background: 'transparent',
        border: '0px solid rgba(255, 255, 255, 0.25)',
        padding: '0px',
      },
      '&.ant-btn:hover, .ant-btn:focus, .ant-btn:active': {
        background: 'transparent',
        border: '0px solid rgba(255, 255, 255, 0.25)',
        padding: '0px',
      },
    },
    divider: {
      '&.ant-divider-horizontal': {
        opacity: 0.5,
        borderTopColor: 'rgb(255 255 255 / 10%)',
      },
    },
    bottomButton: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      padding: '0 0px 15px',
      background: theme.backgroundColor,
      zIndex: 2,
      display: 'flex',
      justifyContent: 'center',
    },
    iconSkeleton: {
      '& .ant-skeleton-avatar': {
        width: 80,
        height: 80,
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
